import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../Css/forgout.css';

const ModalForgotPasswordClient = ({ show, onHide }) => {
    const [email, setEmail] = useState('');

    return (
        <Modal
            show={show} onHide={onHide}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <form>
                <Modal.Body>

                    <h3 className="text-center">Entrer votre adresse e-mail</h3>

                    <input type="email" className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="Adresse e-mail..." />
                    <div className='d-flex justify-content-between'>
                        <button type="button" className='btn btn_close' onClick={onHide}>Fermer</button>
                        <button type="submit" className='btn btn_send' >Envoyé</button>
                    </div>
                </Modal.Body>

            </form>
        </Modal>
    )
}

export default ModalForgotPasswordClient